import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import DefaultLayout from './layouts/default'
import SignatureLayout from './layouts/signature';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import SignatureUnavailablePage from './pages/SignatureUnavailablePage';
import TemplatesPage from './pages/TemplatesPage';
import DashboardAppPage from './pages/DashboardAppPage';
import EntitiesPage from './pages/EntitiesPage';
import SignaturePage from './pages/SignaturePage'
import NewEnvelope from './pages/newEnvelope'
import SignatureFinishedPage from './pages/signatureFinishedPage'
import SignatureManagementMainPage from './pages/SignatureManagementMainPage'
import IntegrationPage from './pages/IntegrationPage'
import CreateEntityForm from './pages/NewEntityPage'
import EnvelopesPage from './pages/EnvelopesPage'
import UpdateEnvelopePage from './pages/EnvelopeUpdatePage'
import SignersPage from './pages/SignersPage';
import SignerEditPage from './pages/SignerEditPage';
import GroupsPage from './pages/GroupsPage';
import GroupEditPage from './pages/GroupEditPage'
import ProfilePage from './pages/ProfilePage';
import DonePage from './pages/DonePage';
import PendingSignaturesPage from './pages/PendingSignaturesPage'
import AutomaticSealPage from './pages/AutomaticSealPage'
import SignatureConfirmationPage from './pages/SignatureConfirmationPage'
import IcpSignatureConfirmationPage from './pages/icpSignatureConfirmationPage'
import BatchSignatureConfirmationPage from './pages/BatchSignatureConfirmationPage'
import BatchEndorsementConfirmationPage from './pages/BatchEndorsementConfirmationPage'
import BatchIcpSignatureConfirmationPage from './pages/batchIcpSignatureConfirmationPage'
import PlansPage from './pages/PlansPage';
import XpressSignatureListPage from './pages/XpressSignatureListPage';
import PlanManagementPage from './pages/PlanManagementPage';
import EnvelopeGroupEditPage from './pages/EnvelopeGroupEditPage';
import EndorsementsPage from './pages/EndorsementsPage';
import BatchEndorsementViewPage from './pages/BatchEndorsementViewPage';
import BatchSignaturePage from './pages/BatchSignaturePage';
import MySignaturesPage from './pages/MySignaturesPage';
import MySignatureDetailsPage from './pages/MySignatureDetailsPage';
import ChancelaAutomaticaPage from './pages/ChancelaAutomaticaPage';
import DashboardIndexRedirect from './components/dashboard-index-redirect/DashboardIndexRedirect';
import TemplateGenerateDocumentPage from './pages/TemplateGenerateDocumentPage';
import TemplateConfigureEnvelopePage from './pages/TemplateConfigureEnvelopePage';

// ----------------------------------------------------------------------

export default function Router(props) {

  // Função para obter o caminho de redirecionamento após login
  const getRedirectPath = () => {
    const savedPath = sessionStorage.getItem('redirectAfterLogin');
    if (savedPath) {
      sessionStorage.removeItem('redirectAfterLogin');
      return savedPath;
    }
    return '/dashboard'; // comportamento padrão
  };

  const routes = useRoutes([
    {
      path: '/dashboard',
      element: props.isAuth ? <DashboardLayout /> : <Navigate to="/login" replace />,
      children: [
        { element: <DashboardIndexRedirect />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'entities', element: <EntitiesPage /> },
        { path: 'signatures/management', element: <SignatureManagementMainPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'templates', element: <TemplatesPage /> },
        { path: 'templates/:templateKey/generate-document', element: <TemplateGenerateDocumentPage /> },
        { path: 'templates/:templateKey/configure-envelope', element: <TemplateConfigureEnvelopePage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'entity', element: <CreateEntityForm /> },
        { path: 'signers', element: <SignersPage /> },
        { path: 'signers/:signerKey/edit', element: <SignerEditPage /> },
        { path: 'groups', element: <GroupsPage /> },
        { path: 'group/:groupKey', element: <GroupEditPage /> },
        { path: 'envelope/group/:groupKey', element: <EnvelopeGroupEditPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'envelopes', element: <EnvelopesPage /> },
        { path: 'xpress/signature', element: <XpressSignatureListPage /> },
        { path: 'envelope/:envelopeKey', element: <UpdateEnvelopePage /> },
        { path: 'envelope', element: <NewEnvelope /> },
        { path: 'done', element: <DonePage /> },
        { path: 'configuration', element: <IntegrationPage /> },
        { path: 'Automaticseal', element: <AutomaticSealPage /> },
        { path: 'pendingSignatures', element: <PendingSignaturesPage /> },
        { path: 'plan/management', element: <PlanManagementPage /> },
        { path: 'endorsements', element: <EndorsementsPage /> },
        { path: 'batch-endorsement/:batchEndorsementKey', element: <BatchEndorsementViewPage /> },
        { path: 'my-signatures', element: <MySignaturesPage /> },
        { path: 'my-signatures/:envelopeKey', element: <MySignatureDetailsPage /> },
        { path: 'chancela-automatica', element: <ChancelaAutomaticaPage /> },
      ],
    },
    {
      path: 'login',
      element: props.isAuth ? <Navigate to={getRedirectPath()} replace /> : <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'plans', element: props.isAuth ? <PlansPage /> : <Navigate to="/login" replace /> },
        { path: '404', element: <Page404 /> },
        { path: 'signature-unavailable', element: <SignatureUnavailablePage /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "/sign",
      element: <DefaultLayout />, // props.isAuth ? <DashboardLayout /> : <Navigate to="/login" replace />,
      children: [
        { element: <Navigate to="/sign/:signerKey" />, index: true },
        { path: ':signerKey', element: <SignaturePage /> },
      ],
    },
    {
      path: "/signature",
      element: <SimpleLayout />, // props.isAuth ? <DashboardLayout /> : <Navigate to="/login" replace />,
      children: [
        { element: <Navigate to="/sign/:signerKey" />, index: true },
        { path: 'finish', element: <SignatureFinishedPage /> },
        { path: ':signerKey/token', element: <SignatureConfirmationPage /> },
        { path: ':signerKey/icp', element: <IcpSignatureConfirmationPage /> },
        { path: ':batchKey/batch/token', element: <BatchSignatureConfirmationPage /> },
        { path: ':batchKey/batch/icp', element: <BatchIcpSignatureConfirmationPage /> },
        { path: ':batchKey/batch/icp-user', element: <BatchIcpSignatureConfirmationPage usuario /> },
        { path: ':batchEnvelopeSignerKey/batch', element: <BatchSignaturePage /> },

      ],
    },
    {
      path: "/endorsement",
      element: <SimpleLayout />,
      children: [
        { path: ':batchKey/batch/token', element: <BatchEndorsementConfirmationPage /> },
        { path: ':batchKey/batch/icp', element: <BatchIcpSignatureConfirmationPage /> },
        { path: ':batchEnvelopeSignerKey/batch', element: <BatchSignaturePage /> },
      ],
    },
  ]);

  return routes;
}
